import list from './clueReportManage'
export default list
